export default {
  name: 'editableCellSelect',
  props: ['text', "align", "selectList", "slotName", "errStatus"],
  // props: {
  // 	text: {},
  // 	align:String,
  // 	selectList:[],
  // 	slotName:String,
  // 	errStatus:{}
  // },
  data: function data() {
    return {
      value: typeof this.text == 'undefined' ? undefined : this.text,
      err: this.errStatus
    };
  },
  watch: {
    text: function text() {
      if (this.text instanceof Array) {
        console.log(this.text);
        this.value = this.text;
      } else {
        this.value = typeof this.text == 'undefined' ? undefined : parseInt(this.text);
      }
      // console.log(this.text)
      // console.log((typeof(this.text) =='undefined'))
    },
    errStatus: function errStatus() {
      console.log('error');
      this.err = this.errStatus;
      console.log(this.err + "productChannelid");
    }
  },
  mounted: function mounted() {
    console.log(this.errStatus);
    // console.log((typeof(this.text) =='undefined'))
  },
  methods: {
    handleChange: function handleChange(e) {
      console.log(e);
      this.value = e;
      if (this.value instanceof Array) {
        if (this.value.length > 0) {
          this.err = false;
        } else {
          this.err = true;
        }
      } else {
        if (this.value || this.value === 0) {
          this.err = false;
        } else {
          this.err = true;
        }
      }
      this.check();
    },
    check: function check() {
      var obj = {
        value: this.value,
        errStatus: this.err
      };
      this.$emit('change', obj);
    }
  }
};